import Vue from 'vue';
import Router from 'vue-router';
import ClientBooking from '../components/client-booking/App.vue';

Vue.use(Router);

export default new Router({
  linkActiveClass: 'active',
  routes: [
    {
      path: '/',
      component: ClientBooking,
      name: 'clientBooking',
      meta: {
        requiresAuth: false,
      },
    },
    {
      path: '*',
      redirect: { name: 'clientBooking' },
    },
  ],
});
